import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerContactDiscount } from 'src/app/classes/customer-contact-discount';
import DiscountTypes from 'src/app/constants/discount-types';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-discounts',
  templateUrl: './discounts.component.html',
  styleUrls: ['./discounts.component.scss'],
})
export class DiscountsComponent  implements OnInit {

  discountTypes = DiscountTypes

  discounts: CustomerContactDiscount[] = []

  constructor(public activeModal: NgbActiveModal,
    private settingsService: SettingsService
  ) { }

  ngOnInit() {
    this.settingsService.discounts().subscribe(discounts => {
      this.discounts = discounts
    })
  }

}
